import { Task } from './-private/task';
import { TaskProperty } from './-private/task-properties';
import { deprecatePrivateModule } from './-private/utils';
deprecatePrivateModule('ember-concurrency/-task-property');
export { Task, TaskProperty };
